import {getSvg} from '../controllers/IconController';

Hop.defineModule('svg-icon-list', (root, param = {}) => {
    const iconName = param.name || null;
    const color = param.color || null;

    if (!iconName) {
        throw new Error('Missing name parameter for your icon module');
    }

    function createIconElement() {
        const i = document.createElement('i');

        i.innerHTML = getSvg(iconName);
        i.classList.add('joy-i');
        i.classList.add('joy-i_loaded');

        if (color) {
            i.classList.add(`joy-i_${color}`);
        }

        return i;
    }

    function insertSvg(node) {
        node.prepend(createIconElement());
    }

    function scanListItems(ul) {
        ul.querySelectorAll('li').forEach((li) => insertSvg(li));
    }

    function scanLists() {
        root.querySelectorAll('ul').forEach((ul) => scanListItems(ul));

        if (root.classList.contains('joy-i_list')) {
            root.classList.add('joy-i_list-loaded');
        }
    }

    function init() {
        scanLists();
    }

    init();

    return function destroy() {
        // Nothing to do here yet.
    };
});

/* webpack-strip-block:removed */
